import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import BorseContext from "../../context/borse";
import UserContext from "../../context/user";

const useBorseDocumentsUploadMutation = () => {
  const { callApi } = useContext(UserContext);
  const { setCurrentRequest } = useContext(BorseContext);

  return useMutation(
    ({ request, files }) =>
      callApi(`/scholarship/request/${request?.id}/provideAdditionalFiles`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ files: files?.map((f) => ({ fileId: f })) }),
      }),
    {
      onSuccess: () => {
        setCurrentRequest();
      },
    }
  );
};

export default useBorseDocumentsUploadMutation;
